<template>
<m-pageframe
    title="Search Employees"
>
<v-container>

    <v-btn
        v-on:click="testSpinner"
    >
        Test Spinner (3 seconds)
    </v-btn>

    <br/>
    <br/>

    <v-btn
        v-on:click="testSnackbar(3000)"
        style="margin-right: 15px;"
    >
        Test Snackbar (3 seconds)
    </v-btn>

    <v-btn
        v-on:click="testSnackbar(-1)"
        style="margin-right: 15px;"
    >
        Test Snackbar (forever)
    </v-btn>

    <br/>
    <br/>

    <v-btn
        v-on:click="testAlert()"
        style="margin-right: 15px;"
    >
        Test Alert
    </v-btn>

    <v-btn
        v-on:click="testAlertWithAfterFunc()"
        style="margin-right: 15px;"
    >
        Test Alert With After Function
    </v-btn>

    <br/>
    <br/>

     <v-btn
        v-on:click="testConfirm()"
        style="margin-right: 15px;"
    >
        Test Confirm
    </v-btn>

    <br/>
    <br/>

    <v-btn
        v-on:click="testPrompt()"
        style="margin-right: 15px;"
    >
        Test Prompt
    </v-btn>

    <v-btn
        v-on:click="testStartRinging()"
        style="margin-right: 15px;"
    >
        Test Call Start Ringing
    </v-btn>

    <v-btn
        v-on:click="testStopRinging()"
        style="margin-right: 15px;"
    >
        Test Call Stop Ringing
    </v-btn>

    <br/>
    <br/>

    <v-btn
        v-on:click="testContactSupport()"
        style="margin-right: 15px;"
    >
        Contact Support
    </v-btn>

    <br/><br/>

    <v-btn
        v-on:click="$refs['test-dialog'].showDialog()"
    >
        Show Dialog
    </v-btn>


</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            
        }
    },

    methods: {
        testSpinner() {
            this.$rc.showSpinner();

            setTimeout(
                () => { this.$rc.hideSpinner(); },
                3000
            );
        },

        testSnackbar(timeout) {
            this.$rc.snackbar("Hello snackbar!", timeout);
        },

        testAlert() {
            this.$rc.alert('Some message', 'Something <b>scary</b> about an error!');
        },

        testAlertWithAfterFunc() {
            this.$rc.alert(
                'So...', 
                'In case of fire, click OK', 

                () => {
                    this.$rc.alert('I said in case of fire!', 'I SAID IN CASE OF FIRE!');
                }
            );
        },

        testConfirm() {

            this.$rc.confirm({
                    'title': 'Confirm Something',
                    'body': 'You need to confirm something',
                    'btn_text_ok': 'Yes',
                    'btn_text_cancel': 'No',
                    'on_ok': () => {
                        this.$rc.alert('After confirm', 'You clicked the yes button');
                    },

                    'on_cancel': () => {
                        this.$rc.alert('After confirm', 'You clicked the no button');
                    }
                });
        },

        testPrompt() {
            this.$rc.prompt({
                'title' : 'Enter some text',
                'label' : 'Your text',
                'after_prompt' : (value) => {
                    this.$rc.alert('You entered...',value);
                }
            });
        },

        testStartRinging()
        {
            this.$rc.$event_bus.$emit(
                'call-start-ringing', 
                {
                    'forward_to_employee_id': this.$rc.$state.employee_id,
                }
            );
        },

        testStopRinging()
        {
            this.$rc.$event_bus.$emit(
                'call-stop-ringing', 
                {
                    'forward_to_employee_id': this.$rc.$state.employee_id,
                }
            );
        },

        testContactSupport()
        {
            this.$rc.contactSupport({
                'page_name': 'Global Controls Test Page',
            });
        },
    },
    
}

</script>

<style lang="scss" scoped>

</style>